export default "__VITE_ASSET__DJ7JkKEs__"